<template>
  <div class="studentifno-editstudent">
    <!-- 编辑表单 -->
    <el-dialog :visible="dialogFormVisible" title="修改学生信息" @open="dialogOpen" @close="dialogClose"
      :close-on-click-modal="false" center width="30%">
      <el-form :model="formData" :rules="rules" ref="ruleForm" style="max-height: 500px; overflow-y: auto;">
        <el-form-item label="姓名" label-width="100px" prop="studentName">
          <el-input v-model="formData.studentName" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="性别" required>
          <el-radio-group v-model="formData.sex">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="学号" label-width="100px" prop="studentNumber">
          <el-input v-model="formData.studentNumber" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label="班级职务" label-width="100px" prop="duty">
          <el-input v-model="formData.duty" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label="政治面貌" label-width="100px" prop="politicsStatus">
          <el-input v-model="formData.politicsStatus" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label="身份证" label-width="100px" prop="idCard">
          <el-input v-model="formData.idCard" autocomplete="off" placeholder="请输入身份证"></el-input>
        </el-form-item>
        <el-form-item label="学生状态" label-width="100px" prop="status">
          <el-select v-model="formData.status" placeholder="请选择">
            <el-option v-for="item in studentTypeList" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="选择班级" label-width="100px" prop="classNameVal">
          <el-cascader v-model="formData.classNameVal" :placeholder="classPlaceholder" :props="classProps"
            :options="classSelect" @change="changeHandle"></el-cascader>
        </el-form-item> -->
        <el-form-item label="选择年级" label-width="100px" prop="gradeId">
          <el-select v-model="formData.gradeId" placeholder="选择年级" @change="selectGrade" clearable>
            <el-option v-for="item in gradeSelectList" :key="item.gradeId" :label="item.gradeName"
              :value="item.gradeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择班级" label-width="100px" prop="classId">
          <el-select v-model="formData.classId" placeholder="选择班级" @change="selectClass" clearable>
            <el-option v-for="item in classSelectList" :key="item.classId" :label="item.className"
              :value="item.classId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="家庭地址" label-width="100px" prop="address">
          <el-input v-model="formData.address" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label="出生年月日" label-width="100px" prop="birthday">
          <el-date-picker v-model="formData.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择出生年月日">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="过敏源" label-width="100px" prop="allergen">
          <el-input v-model="formData.allergen" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label="病史" label-width="100px" prop="medicalHistory">
          <el-input v-model="formData.medicalHistory" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label="民族" label-width="100px" prop="nation">
          <el-input v-model="formData.nation" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label="籍贯" label-width="100px" prop="nativePlace">
          <el-input v-model="formData.nativePlace" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label="毕业小学" label-width="100px" prop="primarySchool">
          <el-input v-model="formData.primarySchool" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label="学生电话" label-width="100px" prop="studentPhone">
          <el-input v-model="formData.studentPhone" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
        <el-form-item label="家长电话" label-width="100px" prop="patriarchPhone">
          <el-input v-model="formData.patriarchPhone" autocomplete="off" :placeholder="placeholder"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  // props: {
  //   dialogFormVisible: {
  //     type: Boolean,
  //     require: true,
  //   },
  //   studentInfo: {
  //     type: Object,
  //     default: () => {
  //       return {};
  //     },
  //   },
  // },
  props: [
    "dialogFormVisible",
    "studentInfo",
    "classPlaceholder",
    "classProps",
    "classSelect",
    "classInfoArr",
    "studentTypeList",
    "gradeSelectList",
  ],
  inject: ["refresh"],
  data() {
    return {
      formData: {
        studentName: "",
        studentNumber: "",
        address: "",
        duty: "",
        politicsStatus: "",
        classNameVal: "",
        status: "",
        sex: "男",
        nation: "",
        birthday: "",
        allergen: "",
        medicalHistory: "",
        nativePlace: "",
        primarySchool: "",
        studentPhone: "",
        patriarchPhone: "",
        classId: "",
        gradeId: "",
        idCard: ""
      },
      classSelectList: [],
      rules: {
        studentName: [
          { required: true, message: "请输入学生姓名", trigger: "blur" },
        ],
        // duty: [{ required: true, message: "请输入班级职务", trigger: "blur" }],
        // politicsStatus: [{ required: true, message: "请输入政治面貌", trigger: "blur" }],
        studentNumber: [
          { required: true, message: "请输入学生学号", trigger: "blur" },
        ],
        gradeId: [
          { required: true, message: "请选择年级", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      placeholder: '请输入'
    };
  },
  mounted() {
    // this.classNameVal = this.classInfoArr;
  },
  methods: {
    // 选择班级
    // 切换年级
    selectGrade(e) {
      // console.log(e);
      this.formData.gradeId = e;
      this.formData.classId = "";
      if (e !== "") {
        this.classSelectList = this.gradeSelectList.find(
          (item) => item.gradeId == e
        ).schoolClassList;
      } else {
        this.gradePlaceholder = "请选择年级";
        this.classSelectList = [];
      }
    },
    selectClass(e) {
      this.formData.classId = e;
    },
    dialogOpen() {
      console.log(this.studentInfo);

      Object.assign(this.formData, this.studentInfo);
      if (this.studentInfo.classId) {
        this.classSelectList = this.gradeSelectList.find(item => item.gradeId == this.studentInfo.gradeId).schoolClassList;
      };
      // this.classSelectList = this.gradeSelectList.find(item => item.gradeId == this.studentInfo.gradeId).schoolClassList;
      this.formData.sex = this.studentInfo.sex ? this.studentInfo.sex : "男";
      this.formData.classNameVal = this.classInfoArr;
    },
    dialogClose() {
      // let { studentName, studentNumber, address } = this.studentInfo;
      // this.formData.studentName = studentName;
      // this.formData.studentNumber = studentNumber;
      // this.formData.address = address;
      this.$emit("update:dialogFormVisible", false);
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // console.log("验证成功,下一步");
          // console.log("this.formData=> ", this.formData);
          let {
            studentName,
            studentNumber,
            address,
            duty,
            politicsStatus,
            status,
            sex,
            nation,
            birthday,
            allergen,
            medicalHistory,
            nativePlace,
            primarySchool,
            studentPhone,
            patriarchPhone,
            gradeId,
            classId,
            idCard
          } = this.formData;
          // 调用接口修改学生信息
          this.post(this.$url.updateStudentPC, {
            id: this.studentInfo.id,
            studentName,
            studentNumber,
            address,
            duty,
            sex,
            status,
            politicsStatus,
            gradeId,
            classId,
            gradeName: this.gradeSelectList.find(item => item.gradeId == gradeId).gradeName,
            className: classId ? this.classSelectList.find(item => item.classId == classId).className : '',
            // gradeId: this.formData.classNameVal[0].gradeId,
            // gradeName: this.formData.classNameVal[0].gradeName,
            // classId: this.formData.classNameVal[1].classId,
            // className: this.formData.classNameVal[1].className,
            nation,
            birthday,
            allergen,
            medicalHistory,
            nativePlace,
            primarySchool,
            studentPhone,
            patriarchPhone,
            idCard
          })
            .then((res) => {
              // console.log(res);
              if (res.code == 200 && res.data == 1) {
                this.$message.success("修改成功");
                // 刷新列表
                this.refresh();
                // 关闭弹出框
                this.dialogClose();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // this.$message.error("修改失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
